import team_member_1 from "../assets/svgs/team_member1.svg";
import team_member_2 from "../assets/svgs/team_member2.svg";
import team_member_3 from "../assets/svgs/team_member3.svg";
import team_member_4 from "../assets/svgs/team_member4.svg";
import team_member_5 from "../assets/svgs/team_member5.svg";
import team_member_6 from "../assets/svgs/team_member6.svg";
import team_member_7 from "../assets/svgs/team_member7.svg";
import caseStudies1 from "../assets/img/caseStudies1.png";
import caseStudies2 from "../assets/img/caseStudies2.png";
import blogImg1 from "../assets/img/blogImg1.png";
import blogImg2 from "../assets/img/blogImg2.png";
import blogImg3 from "../assets/img/blogImg3.png";

export const navLinks = [
  {
    id: 0,
    name: "Home",
    url: "/",
  },

  {
    id: 1,
    name: "Our Firm",
    url: "/our-firm",
  },
  {
    id: 2,
    name: "Practice Areas",
    url: "/practice-areas",
  },
  {
    id: 3,
    name: "Case Studies",
    url: "/case-studies",
  },
  {
    id: 4,
    name: "Contact",
    url: "/contact",
  },
  {
    id: 5,
    name: "Blog",
    url: "/blog",
  },
];

export const teamMembers = [
  {
    id: 0,
    img: team_member_1,
    name: "Ejiga Benjamin Ochuma",
    role: "Managing Partner",
    linkedIn: "linkedin.com/in/ochuma-ejiga-benjamin-10333416",
    facebook: "linkedin.com/in/ochuma-ejiga-benjamin-10333416",
    twitter: "linkedin.com/in/ochuma-ejiga-benjamin-10333416",
  },
  {
    id: 1,
    img: team_member_2,
    name: "DanBauchi Hauwa Anya",
    role: "Associate",
    linkedIn: "https://www.google.com",
    facebook: "https://www.google.com",
    twitter: "https://www.google.com",
  },
  {
    id: 2,
    img: team_member_3,
    name: "Oyibo Stephen Oyibo Esq.",

    role: "Associate",
    linkedIn: "https://www.google.com",
    facebook: "https://www.google.com",
    twitter: "https://www.google.com",
  },
  {
    id: 3,
    img: team_member_4,
    name: "Victor Oyonakpare Esq.",
    role: "Partner",
    linkedIn: "https://www.google.com",
    facebook: "https://www.google.com",
    twitter: "https://www.google.com",
  },
];

export const practiceAreas = [
  {
    id: 0,
    title: "Arbitration & Mediation",
    desc: `Our adept legal team adeptly guides clients through complex arbitration and mediation processes, leveraging a strong understanding of alternative dispute resolution methods.`,
    overview: `Arbitration, Conciliation and Mediation are Alternative Dispute Resolution for solving civil nature disputes. Through these methods our Firm has resolved complex commercial disputes without resort to regular judicial system, i.e regular courts. With the growth of commerce and technology start-ups, it has become expedient for disputes to be resolved speedily, hence Arbitration, mediation and Conciliation has become a sine qua non`,
    pros: [
      {
        heading: "Efficiency",
        text: "Arbitration is often faster than litigation. It allows parties to resolve disputes without the lengthy court process, saving time and resources.",
      },
      {
        heading: "Privacy",
        text: "Arbitration proceedings are typically private, keeping sensitive matters confidential.",
      },
      {
        heading: "Flexibility",
        text: "Parties have more control over the arbitration process, including choosing the arbitrator and the rules governing the proceedings.",
      },
    ],
  },
  {
    id: 1,
    title: "Intellectual Property",
    desc: `we are committed to safeguarding your creative works and innovative ideas. Our seasoned legal team specializes in trademarks, copyrights, patents, and trade secrets, offering holistic protection for your intellectual assets.`,
    overview: `The Firm is passionate about protecting the intellectual property of Clients hence the Firm is accredited as Trademark, Patents, designs and copyright agents. Our accreditations has positioned the Firm for the protection of clients creativity, be it Inventions, brands, books, music, art, filming, writing etc and also provide all the necessary steps required to protect such person’s rights, and ensures that our clients reaps the benefit of their creative ability.`,
    pros: [
      {
        heading: "Strategic Advice",
        text: "A legal expert provides strategic guidance for safeguarding and optimizing your intellectual property assets, ensuring decisions align with your business objectives",
      },
      {
        heading: "Registration and Enforcement",
        text: " A legal expert manages the registration of trademarks, copyrights, patents, and trade secrets, ensuring robust legal protection. They can also take legal action to enforce your IP rights in case of infringement.",
      },
      {
        heading: "Risk Mitigation",
        text: "Legal experts can conduct thorough IP searches to identify potential conflicts, helping to mitigate the risk of infringing on existing intellectual property and avoiding costly legal disputes.",
      },
    ],
  },
  {
    id: 2,
    title: "Regulatory Compliance",
    desc: `Our Regulatory Compliance services are tailored to navigate complex regulations for businesses. Our skilled legal team helps clients grasp and comply with evolving rules, cultivating an accountable culture.`,
    overview: `Arbitration, Conciliation and Mediation are Alternative Dispute Resolution for solving civil nature disputes. Through these methods our Firm has resolved complex commercial disputes without resort to regular judicial system, i.e regular courts. With the growth of commerce and technology start-ups, it has become expedient for disputes to be resolved speedily, hence Arbitration, mediation and Conciliation has become a sine qua non`,
    pros: [
      {
        heading: "Efficiency",
        text: "Arbitration is often faster than litigation. It allows parties to resolve disputes without the lengthy court process, saving time and resources.",
      },
      {
        heading: "Privacy",
        text: "Arbitration proceedings are typically private, keeping sensitive matters confidential.",
      },
      {
        heading: "Flexibility",
        text: "Parties have more control over the arbitration process, including choosing the arbitrator and the rules governing the proceedings.",
      },
    ],
  },
  {
    id: 3,
    title: "Banking & Insurance",
    desc: `We offer comprehensive Banking & Insurance services, combining legal expertise with financial insight. Our team excels in navigating regulations and providing strategic guidance.`,
    overview: `Our  banking and finance law practice includes advising and representing Clients not only with respect to lending and regulatory compliance, but also with respect to fiduciary activities, securitizations, payment systems, electronic banking, data security, and risk management. Our Banking practice also covers mergers, corporate organizational and ownership issues involving holding companies, banks, and other regulated entities.`,
    pros: [
      {
        heading: "Due Diligence",
        text: "Attorneys conduct thorough due diligence for banking and insurance transactions, identifying potential legal issues and safeguarding your interests.",
      },
      {
        heading: "Financial Regulations",
        text: "Legal experts stay abreast of evolving financial regulations, ensuring your banking and insurance practices align with current legal standards.",
      },
      {
        heading: "Contractual Negotiations",
        text: "Lawyers negotiate terms and conditions in banking and insurance contracts, securing favorable arrangements and protecting your legal rights.",
      },
      {
        heading: "Policy Guidance",
        text: "Lawyers provide guidance on policy matters, helping businesses navigate intricate insurance policies and banking transactions.",
      },
      {
        heading: "Contract Drafting and Review",
        text: "Attorneys proficient in banking and insurance law draft and review contracts, ensuring clarity, legality, and protection of your interests.",
      },
    ],
  },
  {
    id: 4,
    title: "Real Estate Practice",
    desc: `Our Real Estate services focus on expertly navigating property transactions. With a our legal team, we provide guidance on acquisitions, leasing, development, and beyond.`,
    overview: `Our Firm has assembled a leading property consultant to deliver sterling results for our Clients. Our Property department has advised and consulted for top property firms, 
    estate developers and private property buyers. Our firm is well experienced in the intricacies of property due diligence, perfection of titles, obtaining necessary approvals and permits for estate development etc. 
    Our Infrastructure expertise covers power generation and distribution projects, roads, ports, transit, telecommunications, oil and gas, aviation, waste management and railways. We assist clients in public/private partnerships, 
    hybrid financings, blending elements of cash-flow lending and project finance. We are regularly involved in complex capital structures with debt/equity co-investment and sophisticated inter-investor/creditor arrangements`,
    pros: [
      {
        heading: "Legal Expertise",
        text: "A legal practitioner brings specialized knowledge in real estate law, ensuring that transactions adhere to legal requirements and regulations.",
      },
      {
        heading: "Contractual Guidance",
        text: "Attorneys can provide thorough reviews and guidance on real estate contracts, protecting your interests and minimizing potential risks.",
      },
      {
        heading: "Risk Mitigation",
        text: "Lawyers help mitigate risks by identifying potential legal pitfalls, ensuring that real estate transactions are executed with a clear understanding of potential challenges.",
      },
      {
        heading: "Transaction Support",
        text: "Attorneys assist in the entire real estate transaction process, from drafting and reviewing contracts to coordinating closings, providing a seamless and legally sound experience.",
      },
      {
        heading: "Legal Due Diligence",
        text: "Legal practitioners conduct thorough due diligence to uncover any legal issues related to the property, ensuring informed decision-making.",
      },
    ],
  },
  {
    id: 5,
    title: "General Litigation",
    desc: `At Stratagem LP, With our proficient legal team, we handle a diverse range of cases, including commercial and civil litigation, as well as alternative dispute resolution.`,
    overview: `This firm can confidently boast of an assemblage of the best litigators, advocates and Attorneys that have done remarkable exploits in Nigeria. The Founding partner E.B Ochuma Esq. has garnered over 18 (eighteen) years of litigation experience and to crown it, he has kept a clean slate till date.`,
    pros: [
      {
        heading: "Advocacy",
        text: "Lawyers act as strong advocates for your interests in legal disputes, representing you with professionalism and diligence.",
      },
      {
        heading: "Case Strategy",
        text: "Legal professionals develop effective case strategies tailored to your specific situation, maximizing the likelihood of a favorable outcome.",
      },
      {
        heading: "Procedural Compliance",
        text: "Legal practitioners ensure strict adherence to legal procedures, minimizing the risk of procedural errors that could jeopardize your case.",
      },
      {
        heading: "Legal Research and Analysis",
        text: "Attorneys conduct thorough legal research and analysis, ensuring that your case is supported by sound legal arguments and precedents.",
      },
    ],
  },
  {
    id: 6,
    title: "Immigration Law",
    desc: `The Firm has attained expertise in immigration law practice and in so doing, we have assisted Clients in obtaining Expatriate Quota, Resident permit, business permit and citizenship.`,
    overview: `The Firm has attained expertise in immigration law practice and in so doing, we have assisted Clients in obtaining Expatriate Quota, Resident permit, business permit and citizenship.`,
    pros: [
      {
        heading: "Legal Expertise",
        text: "Legal practitioners specialized in immigration law possess in-depth knowledge, ensuring accurate and up-to-date advice on immigration matters.",
      },
      {
        heading: "Visa Application Assistance",
        text: "Attorneys provide comprehensive support for visa applications, guiding individuals and businesses through the complex application process.",
      },
      {
        heading: "Compliance Assurance",
        text: "Lawyers ensure strict adherence to immigration laws and regulations, reducing the risk of legal issues and enhancing compliance with changing requirements.",
      },
      {
        heading: "Deportation Defense",
        text: "Legal professionals represent individuals facing deportation, employing legal strategies to defend their rights and explore avenues for relief.",
      },
      {
        heading: "Family Immigration Matters",
        text: "Attorneys assist with family-based immigration, facilitating reunification and guiding through the process of sponsoring family members.",
      },
    ],
  },
  {
    id: 7,
    title: "Documentation",
    desc: `The Solicitors department is well-versed in the latest advancements, supported by an extensive collection of over ten thousand commercial agreement precedents.`,
    overview: `Our firm excels in legal drafting, conveyance, and title registration. The Solicitors department is well-versed in the latest advancements, supported by an extensive collection of over ten thousand commercial agreement precedents.`,
    pros: [
      {
        heading: "Risk Mitigation",
        text: " Legal professionals assess and mitigate potential legal risks associated with documents, protecting your interests and minimizing liabilities.",
      },
      {
        heading: "Customization",
        text: "Attorneys tailor documentation to meet the specific needs and objectives of your business, ensuring that agreements are drafted with your unique requirements in mind.",
      },
      {
        heading: "Contractual Clarity",
        text: "Lawyers ensure clarity in contracts and agreements, minimizing the likelihood of misunderstandings and disputes by precisely defining terms and conditions.",
      },
      {
        heading: "Legal Advice",
        text: "Attorneys provide valuable legal advice throughout the documentation process, offering insights to optimize agreements and protect your legal rights.",
      },
    ],
  },
  {
    id: 8,
    title: "Central Bank Of Nigeria",
    desc: `Our firm specializes in guiding entities through the necessary processes to meet CBN's requirements and obtain licenses for conducting banking and financial activities in Nigeria.`,
    overview: `The Central Bank is the Apex Bank of Nigeria charged with the responsibility of administering the Banks and Other Financial Institutions Act (BOFIA), 2020, with the sole aim of ensuring high standards of banking practice and financial stability through its surveillance activities, as well as the promotion of an efficient payment system. To carry out Banking business and other financial institutions in Nigeria, the entity must comply with the requirements laid down by the CBN, our Regulatory Compliance department are versed in packaging these entities to meet these requirements and obtain these licenses.`,
    pros: [
      {
        heading: "Regulatory Expertise",
        text: "A legal team ensures in-depth understanding and adherence to the complex regulatory landscape set by the Central Bank of Nigeria (CBN) under BOFIA, 2020.",
      },
      {
        heading: "Risk Mitigation",
        text: "Legal experts identify and mitigate risks associated with banking practices, safeguarding the entity from potential legal challenges and financial instability.",
      },
      {
        heading: "Licensing Facilitation",
        text: "The legal team facilitates the licensing process, streamlining procedures and ensuring the entity meets all requirements for carrying out banking and financial operations.",
      },
      {
        heading: "Payment System Optimization",
        text: "The legal team contributes to optimizing the payment system, aligning the entity with CBN guidelines for the promotion of an efficient payment infrastructure.",
      },
      {
        heading: "Strategic Guidance",
        text: "Legal experts offer strategic guidance, helping the entity navigate the evolving regulatory landscape and make informed decisions for sustained success in the banking and financial sector.",
      },
    ],
  },
  {
    id: 9,
    title: "Ministry Of Interior",
    desc: `Our firm has the expertise in handling complex documentations and related services to enable your company meet the requirements and obtain the necessary permits and licenses.`,
    overview: `This is the parent Ministry that oversees the activities of the following Federal Government Agencies and parastatals. Nigeria Immigration, Nigerian Correctional Service, Federal Fire Service, Nigeria Security and Civil Defence Corp Several companies are required to comply with the regulatory requirements of these agencies and the agencies have laid down stringent requirements for compliance. Our firm has the expertise in handling these complex documentations and related services to enable your company meets these requirements and obtain the necessary permits and licenses such as Expatriate Quota, Resident and Business permits, Private Security license.`,
    pros: [
      {
        heading: "Expertise in Agency Compliance",
        text: "A legal team navigates and ensures compliance with regulatory requirements from federal agencies, including Nigeria Immigration, Nigerian Correctional Service, Federal Fire Service, and Nigeria Security and Civil Defence Corp",
      },
      {
        heading: "Strategic Guidance",
        text: "Legal experts offer strategic guidance to help companies align their operations with stringent regulatory requirements set by the overseeing Ministry and its associated agencies.",
      },
      {
        heading: "Permit and License Procurement",
        text: "Legal professionals streamline the procurement of permits and licenses, including Expatriate Quota, Resident and Business permits, and Private Security licenses, easing the process for the company",
      },
      {
        heading: "Enhanced Legal Representation",
        text: "In case of disputes or legal challenges related to compliance, having a legal team ensures the company is well-represented and capable of navigating complex legal issues.",
      },
    ],
  },
  {
    id: 10,
    title: "Insolvency, Liquidation & Administration",
    desc: `Stratagem combines an extensive senior secured lending practice with a strong debtor-side practice, enabling it to oversee the full-spectrum of restructuring and bankruptcy matters.`,
    overview: `Stratagem combines an extensive senior secured lending practice with a strong debtor-side practice, enabling it to oversee the full-spectrum of restructuring and bankruptcy matters.`,
    pros: [
      {
        heading: "Comprehensive Oversight",
        text: "With expertise in senior secured lending and debtor-side practices, Stratagem provides comprehensive oversight of the entire spectrum of restructuring and bankruptcy matters.",
      },
      {
        heading: "Specialized Knowledge",
        text: "Legal experts at Stratagem possess specialized knowledge in senior secured lending, ensuring a deep understanding of complex financial transactions.",
      },
      {
        heading: "Debtor-Side Strength",
        text: "The firm's strong debtor-side practice enhances its ability to represent and advocate for the interests of clients facing financial challenges",
      },
      {
        heading: "Holistic Approach",
        text: `Stratagem's combination of practices allows for a holistic approach to restructuring, addressing both lending and debtor perspectives for a well-rounded strategy.
        Efficient Resolution: With a full-spectrum approach, Stratagem aims for efficient resolution of restructuring and bankruptcy matters, minimizing delays and optimizing outcomes.
        `,
      },
    ],
  },
  {
    id: 11,
    title: "Project Finance",
    desc: `We guide clients through public-private partnerships, hybrid financings, and infrastructure concessions, incorporating elements of cash-flow lending and project finance.`,
    overview: `The multidisciplinary background of our team, combined with local and international exposure to infrastructure transactions, places Stratagem in a prime advisory position in this emerging sector. 
    Our expertise covers power generation and distribution projects, roads, ports, transit, telecommunications, oil and gas, aviation, waste management, renewable energy and railways. We assist clients in public/private partnerships, 
    hybrid financings, infrastructure concession blending elements of cash-flow lending and project finance. We are regularly involved in complex capital structures with debt/equity co-investment and sophisticated inter-investor/creditor arrangements.`,
    pros: [
      {
        heading: "Local and International Exposure",
        text: "The team's exposure to both local and international infrastructure transactions positions Stratagem as a valuable advisor, offering insights that span global and regional perspectives.",
      },
      {
        heading: "Prime Advisory Standing",
        text: "With a multidisciplinary background and extensive exposure, Stratagem holds a prime advisory standing in the emerging sector of infrastructure transactions.",
      },
      {
        heading: "Public/Private Partnerships:",
        text: "Stratagem assists clients in navigating the complexities of public/private partnerships, providing legal guidance tailored to the unique challenges of these collaborative ventures.",
      },
      {
        heading: "Debt/Equity Co-Investment",
        text: `The firm is regularly involved in complex capital structures, offering legal expertise in debt/equity co-investment scenarios to optimize financial arrangements.
        `,
      },
    ],
  },
  {
    id: 12,
    title: "Federal Capital Development Authority",
    desc: `We specialize in legal compliance, transaction support, and representation to ensure clients navigate FCDA regulations seamlessly.`,
    overview: `The FCDA is vested with the responsibility of administering the Federal Capital Territory Act 1976, 
    its core responsibilities of planning, development and administration of the Federal Capital City and the Federal 
    Capital Territory as a whole. The FCDA is the FCT State Secretariat. The Abuja Geographic information system 
    is the FCT Land Registry and the Department of Development Control is the FCT state Urban and Regional Planning department. 
    Estate Development in the FCT cannot be legally carried on without the approval of the FCDA department stated above. Our Abuja office is located 1 m to AGIS, FCDA and we have competent personnel to handle client’s briefs in this regard.`,
    pros: [
      {
        heading: "FCDA Approval Necessity",
        text: "Estate development in the Federal Capital Territory requires legal approval from the FCDA, making legal expertise crucial for compliance and project success.",
      },
      {
        heading: "Proximity to Regulatory Bodies",
        text: "Stratagem's Abuja office is strategically located in close proximity to the FCDA, Abuja Geographic Information System (AGIS), and the Department of Development Control, facilitating efficient engagement with these regulatory bodies.",
      },
      {
        heading: "Competent Personnel",
        text: "The firm boasts competent personnel with the expertise needed to handle client briefs related to FCDA matters, ensuring effective and knowledgeable representation.",
      },
      {
        heading: "Urban and Regional Planning",
        text: `Stratagem specializes in matters related to Urban and Regional Planning, a critical aspect overseen by the Department of Development Control in the FCDA.`,
      },
      {
        heading: "Land Registry Understanding",
        text: `Stratagem acknowledges the significance of the Abuja Geographic Information System (AGIS) as the FCT Land Registry, ensuring clients receive expert advice on land-related matters.`,
      },
    ],
  },
  {
    id: 13,
    title: "Corporate Affairs Commission",
    desc: `Our law firm provides expert assistance in registering business and company names with the Corporate Affairs Commission (CAC) in Nigeria. We streamline the registration process.`,
    overview: `This is Nigeria’s Central Company Registry vested with the responsibility of administering the Companies and Allied Matters Act 2020, including the regulation and supervision of the formation, incorporation, management and winding up of companies. Our firm has over 2 (two) decades experience in this area of Corporate practice.`,
    pros: [
      {
        heading: "Regulatory Compliance",
        text: "Our firm, with its understanding of the Companies and Allied Matters Act 2020, ensures strict compliance with regulatory requirements in the formation, incorporation, management, and winding up of companies.",
      },
      {
        heading: "Expert Administration",
        text: "As Nigeria's Central Company Registry, our firm expertly administers corporate regulations, providing a reliable resource for businesses navigating legal intricacies.",
      },
      {
        heading: "Incorporation Support",
        text: "Our firm provides essential support in the incorporation process, ensuring that companies meet all legal requirements and documentation for a lawful and recognized status.",
      },
      {
        heading: "Urban and Regional Planning",
        text: `Stratagem specializes in matters related to Urban and Regional Planning, a critical aspect overseen by the Department of Development Control in the FCDA.`,
      },
      {
        heading: "Land Registry Understanding",
        text: `Stratagem acknowledges the significance of the Abuja Geographic Information System (AGIS) as the FCT Land Registry, ensuring clients receive expert advice on land-related matters.`,
      },
    ],
  },
  {
    id: 14,
    title: "Bureau of Public Procurement",
    desc: `Our firm specializes in facilitating the registration process with the Bureau of Public Procurement (BPP), a mandatory requirement for contractors.`,
    overview: `Every Contractor both in Nigeria and in diaspora must be duly registered with the BPP before they can be eligible to bid for Government contracts. Our Firm has the requisite expertise and experience to assist both intending and existing companies. The Public Procurement Act 2007 established the Bureau of Public Procurement as the regulatory authority responsible for the monitoring and oversight of public procurement, harmonizing the existing government policies and practices by regulating, setting standards and developing the legal framework and professional capacity for public procurement in Nigeria.`,
    pros: [
      {
        heading: "Legal Compliance Assurance",
        text: "Stratagem Legal Practitioners can ensure that contractors comply with the Public Procurement Act 2007 and BPP regulations, minimizing the risk of legal issues and disqualification.",
      },
      {
        heading: "Expertise in Public Procurement Laws",
        text: "Stratagem can guide contractors through the BPP registration process, ensuring all necessary documentation is in order, which is vital for eligibility to bid on government contracts.",
      },
      {
        heading: "Dispute Resolution",
        text: "Our team of experts can represent contractors in legal matters, including dispute resolution mechanisms, ensuring fair and favorable outcomes in case of disagreements during the bidding process or contract execution.",
      },
      {
        heading: "Document Drafting and Review",
        text: `The legal practitioners can assist in drafting and reviewing legal documents, including contracts and bid proposals, ensuring compliance with legal requirements and protecting the contractor's rights.`,
      },
    ],
  },
];

export const caseStudies = [
  {
    id: 0,
    img: caseStudies1,
    title: `EKWEKWUO V. ABDULLAHI & ORS Reported as (2020)LPELR-51363(CA)`,
    case: {
      aboutTheCase: `Is a Landmark case hinged on the validity of Allocation of Land by the Area Councils (Local Government) in the Federal Capital Territory. In this case commenced at the High Court of FCT IN 2011, we successfully argued that the FCT is like any other states and that the Area Council have the Power to allocate Land by issues the Customary Certificate of Occupancy like their Counterparts in every other state of the Federal in accordance with the Land Use Act. We won at both the High Court and the Court of Appeal and the case is presently pending at the Supreme Court `,
      clientsNeed: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus. Cum mattis mollis odio gravida adipiscing. 
      Facilisis scelerisque non lacinia tincidunt faucibus tortor vel. 
      Erat risus etiam quam pretium ornare. Semper orci arcu pulvinar adipiscing pretium. 
      Erat facilisis dis arcu senectus sit mi fermentum eu aliquam. 
      Felis neque posuere pharetra porttitor lacinia proin pretium. 
      Et et pharetra tincidunt vel egestas risus sed mollis adipiscing. 
      Lobortis risus mauris vitae pellentesque lobortis sapien. 
      Mi convallis leo nisl pharetra quam arcu blandit. Metus nisl volutpat ut sed sit sit est. `,
      challenges: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.
      Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. Proin ac a cursus praesent. 
      Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.`,
      howWeWon: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. Proin ac a cursus praesent.`,
    },
  },
  {
    id: 1,
    img: caseStudies2,
    title: `ASSET MANAGEMENT CORPORATION OF NIGERIA V. CHIEF ENGINEERS (NIG)LTD & ORS reported as (2023) LPELR-61121(CA) `,
    case: {
      aboutTheCase: `In this case we successfully defended our Client against the AMCON. Here we urged the Court to decline Jurisdiction to entertain AMCON's suit on the ground that the case is Statute Barred i.e caught up by the limitation Law of Lagos. The Federal High Court agreed with us and declined Jurisdiction. The Court of Appeal also agreed with us and declined jurisdiction, thereafter AMCON has gone on further Appeal to the Supreme Court of last resort.`,
      clientsNeed: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus. Cum mattis mollis odio gravida adipiscing. 
      Facilisis scelerisque non lacinia tincidunt faucibus tortor vel. 
      Erat risus etiam quam pretium ornare. Semper orci arcu pulvinar adipiscing pretium. 
      Erat facilisis dis arcu senectus sit mi fermentum eu aliquam. 
      Felis neque posuere pharetra porttitor lacinia proin pretium. 
      Et et pharetra tincidunt vel egestas risus sed mollis adipiscing. 
      Lobortis risus mauris vitae pellentesque lobortis sapien. 
      Mi convallis leo nisl pharetra quam arcu blandit. Metus nisl volutpat ut sed sit sit est. `,
      challenges: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.
      Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. Proin ac a cursus praesent. 
      Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.`,
      howWeWon: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. Proin ac a cursus praesent.`,
    },
  },
  {
    id: 2,
    img: caseStudies2,
    title: `APATA V. HON MINISTER OF FCT & ANOR Reported as (2023) LPELR-60495(CA)`,
    case: {
      aboutTheCase: `The subject matter of this case is the sale of Federal Government Property in Abuja FCT. The Plaintiff/Appellant alleged that the contract he signed with the Minister of FCT was unlawfully terminated before the Minister sold the property to our Client.
      We successfully defended our Client's interest by urging the Court to decline Jurisdiction to entertain the case on the ground that the Writ of Summons that initiated the case was not signed by either the Litigant or his Legal Practitioners. The High Court and the Court of Appeal agreed with us and declined Jurisdiction to entertain the case. The Appellant has gone on Final Appeal to the Supreme Court.
      `,
      clientsNeed: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus. Cum mattis mollis odio gravida adipiscing. 
      Facilisis scelerisque non lacinia tincidunt faucibus tortor vel. 
      Erat risus etiam quam pretium ornare. Semper orci arcu pulvinar adipiscing pretium. 
      Erat facilisis dis arcu senectus sit mi fermentum eu aliquam. 
      Felis neque posuere pharetra porttitor lacinia proin pretium. 
      Et et pharetra tincidunt vel egestas risus sed mollis adipiscing. 
      Lobortis risus mauris vitae pellentesque lobortis sapien. 
      Mi convallis leo nisl pharetra quam arcu blandit. Metus nisl volutpat ut sed sit sit est. `,
      challenges: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.
      Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. Proin ac a cursus praesent. 
      Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.`,
      howWeWon: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. Proin ac a cursus praesent.`,
    },
  },
  {
    id: 3,
    img: caseStudies2,
    title: `EFCC V. AJAYI TOPE SAMUEL (Unreported-Court of Appeal Kano`,
    case: {
      aboutTheCase: `Here, we successfully defended our Client that was unlawfully arrested and prosecuted by the EFCC under the EFCC Act, The Cybercrimes Act and the Advanced Fee Fraud Act upon the petition and instigation of Multichoice Nigeria. We successfully defended our Clients and they were discharged and acquitted of all the 3 Counts charge by both the Federal High Court and the Court of Appeal Kano. We have since sued Multichoice Nigeria who is the Nominal Complainant claiming damages of 1 Billion Naira for Malicious prosecution`,
      clientsNeed: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus. Cum mattis mollis odio gravida adipiscing. 
      Facilisis scelerisque non lacinia tincidunt faucibus tortor vel. 
      Erat risus etiam quam pretium ornare. Semper orci arcu pulvinar adipiscing pretium. 
      Erat facilisis dis arcu senectus sit mi fermentum eu aliquam. 
      Felis neque posuere pharetra porttitor lacinia proin pretium. 
      Et et pharetra tincidunt vel egestas risus sed mollis adipiscing. 
      Lobortis risus mauris vitae pellentesque lobortis sapien. 
      Mi convallis leo nisl pharetra quam arcu blandit. Metus nisl volutpat ut sed sit sit est. `,
      challenges: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.
      Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. Proin ac a cursus praesent. 
      Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.`,
      howWeWon: `Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. 
      Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. 
      Proin ac a cursus praesent. Malesuada risus amet nunc posuere rhoncus accumsan congue id dolor. 
      Convallis maecenas sed in pellentesque. Diam tristique semper mauris dolor amet. 
      Dolor elit nunc et purus quam amet laoreet eu risus.Lorem ipsum dolor sit amet consectetur. 
      Commodo pulvinar molestie pellentesque urna libero velit porta. Velit pellentesque hac gravida pellentesque est semper. 
      Duis lectus gravida ultricies eleifend in pharetra faucibus orci sem. Proin ac a cursus praesent.`,
    },
  },
];

export const blogPosts = [
  {
    id: 0,
    img: blogImg1,
    title: `How Can your Start Up hire a quality lawyer?`,
    article: `Starting a new venture can be exciting and challenging. 
    It is important that you hire a lawyer too as all companies, 
    irrespective of their size, need legal representation. 
    When you start your business, 
    you will find that you need legal guidance at every step and at different phases of the business life, 
    from the initial incorporation to raising capital for expansion to hiring employees, you need the services of a good lawyer. 
    It goes without saying that most businessmen cannot handle the legal matters in a way that professional and competent lawyers can. 
    You need to find a law office so that you can find the best representation that will be best for your business needs and is also affordable. 
    One of the important things that you need to consider is that the lawyer you hire is specialized in the industry you are starting a business in. 
    The lawyer will have a clear idea about the industry and will know about the legal obstacles that you can face. 
    The lawyer will be able to help your startup by covering all the legal tracks right from the start, 
    so that you can grow your business without having to worry about any legal loopholes that may threaten your dream venture.
    We can also help you with lawsuits against negligent parties for different issues such as inadequate security, 
    wrong hiring practices and also lawsuits against schools, companies, nursing homes, employers, hotels, apartment complexes, 
    say care centers and more. You can get quotations from several lawyers and choose the one that best fits your budget. 
    But ensure that you choose a competent lawyer by interviewing them before hiring. 
    Remember that an efficient lawyer can make a big difference to your case, so it is important that you spend some time in finding the best lawyer to seek advice from for your legal matters.
    `,
    comments: [
      {
        user: `Benjamin`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
      {
        user: `Rhema`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
    ],
  },
  {
    id: 1,
    img: blogImg2,
    title: `Legal Tips`,
    article: `In 1999 Maduro was a member of the National Constituent Assembly that rewrote the constitution that was part of Chávez’s ascent to the presidency. That year Maduro also served in the Chamber of Deputies (the lower house of the Venezuelan legislature), which was eliminated when the legislature became the unicameral National Assembly, in which Maduro began serving in 2000. He was reelected in 2005 and served as the body’s president until 2006, when he became foreign minister. In that capacity he worked to advance the goals of the Bolivarian Alliance for the Peoples of Our America (ALBA), which sought to increase social, political, and economic integration in Latin America and to blunt U.S. influence in the region. He also helped cultivate friendly relations for Venezuela with such controversial world leaders as Libya’s Muammar al-Qaddafi, Zimbabwe’s Robert Mugabe, and Iran’s Mahmoud Ahmadinejad.
Maduro’s profile in the administration began to grow, especially as Chávez’s health began to deteriorate, beginning with Chávez’s initial announcement in 2011 that he had cancer. In October 2012, following Chávez’s triumph in the presidential election over Henrique Capriles Radonski, Maduro became vice president. At the same time, Maduro’s wife (herself a former president of the National Assembly) was serving as Venezuela’s attorney general, which led to the perception of the two as the country’s ultimate political power couple. Before leaving for another round of surgery in Cuba in December 2012, Chávez named Maduro as his preferred successor should he not survive. Indeed, while most of the world was kept in the dark regarding Chávez’s status during a postsurgery recovery in Cuba that forced the postponement of his inauguration in January 2013, Maduro, ever the loyal chavista, acted as the country’s de facto leader. His principal rival for power within the chavismo movement was the president of the National Assembly at that time, Diosdado Cabello, who was widely perceived as the favourite of the military, whereas Maduro was seen as having the support of Chávez’s pivotal ally the Castro regime in Cuba.
   
   Personal life:
   Maduro has been married twice. His first marriage was to Adriana Guerra Angulo, with whom he had his only son, Nicolás Maduro Guerra, also known as “Nicolasito”, who was appointed to several senior government posts (Chief of the Presidency’s Special Inspectors Body, head of the National Film School, and a seat in the National Assembly). He later married Cilia Flores, a lawyer and politician who replaced Maduro as president of the National Assembly in August 2006, when he resigned to become Minister of Foreign Affairs, becoming the first woman to serve as president of the National Assembly. The two had been in a romantic relationship since the 1990s when Flores was Hugo Chávez’s lawyer following the 1992 Venezuela coup d’état attempts and were married in July 2013 months after Maduro became president. While they have no children together, Maduro has three step-children from his wife’s first marriage to Walter Ramón Gavidia; Walter Jacob, Yoswel, and Yosser.
   `,
    comments: [
      {
        user: `Benjamin`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
      {
        user: `Rhema`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
    ],
  },
  {
    id: 3,
    img: blogImg3,
    title: ` 6 tips to avoid expensive legal advice`,
    article: `If you need legal advice for your business or personal matters, hiring quality and professional lawyers may cost you a lot of money. But, it is always advisable to opt for quality legal services. Here are some tips that will help you to avoid the high cost of legal advice. If you belong to the low-income group, you can make use of a large network of legal aid programs that operate on federal agents. You can use these programs and get free legal advice for your problem.
    We can also help you with lawsuits against negligent parties for different issues such as inadequate security, wrong hiring practices and also lawsuits against schools, companies, nursing homes, employers, hotels, apartment complexes, say care centers and more. You can get quotations from several lawyers and choose the one that best fits your budget. But ensure that you choose a competent lawyer by interviewing them before hiring. Remember that an efficient lawyer can make a big difference to your case, so it is important that you spend some time in finding the best lawyer to seek advice from for your legal matters.
    
    We can also help you with lawsuits against negligent parties for different issues such as inadequate security, wrong hiring practices and also lawsuits against schools, companies, nursing homes, employers, hotels, apartment complexes, say care centers and more.
    
    Many online self-help legal websites provide free legal advice to people. You can submit your questions online on these websites and then they are answered by lawyers or paralegals.
    `,
    comments: [
      {
        user: `Benjamin`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
      {
        user: `Rhema`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
    ],
  },
  {
    id: 4,
    img: blogImg3,
    title: ` 6 Strategies to Avoid High Legal Expenses.`,
    article: `Starting a new venture can be exciting and challenging. It is important that you hire a lawyer too as all companies, irrespective of their size needs legal representation. When you start your business, you will find that you need legal guidance at every step and at different phases of the business life, from the initial incorporation to raising capital for expansion to hiring employees, you need the services of a good lawyer. It goes without saying that most businessmen cannot handle the legal matters in a way that professional and competent lawyers can.
    You need to find a law office so that you can find the best representation that will be best for your business needs and is also affordable. One of the important thing that you need to consider is that the lawyer you hire is specialized in the industry you are starting a business. The lawyer will have clear idea about the industry and will know about the legal obstacles that you can face. The lawyer will be able to help your startup by covering all the legal tracks right from the start, so that you can grow your business without having to worry about any legal loopholes that may threaten dream venture.
    We can also help you with lawsuits against negligent parties for different issues such as inadequate security, wrong hiring practices and also lawsuits against schools, companies, nursing homes, employers, hotels, apartment complexes, say care centres and more. You can get quotation from several lawyers and choose the one that best fits your budget. But ensure that you choose a competent lawyer by interviewing them before hiring. bRemember that an efficient lawyer can make a big difference to your case, so it is important that you spend some time in finding the best lawyer to seek advice from for your legal matters.`,
    comments: [
      {
        user: `Benjamin`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
      {
        user: `Rhema`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
    ],
  },
  {
    id: 5,
    img: blogImg3,
    title: `What services are available for crime victims`,
    article: `It is important that you hire a lawyer too as all companies, irrespective of their size, need legal representation. When you start your business, you will find that you need legal guidance at every step and at different phases of the business life, from the initial incorporation to raising capital for expansion to hiring employees, you need the services of a good lawyer. It goes without saying that most businessmen cannot handle the legal matters in a way that professional and competent lawyers can.
    Many online self-help legal websites provide free legal advice to people. You can submit your questions online on these websites and then they are answered by lawyers or paralegals.
    We can also help you with lawsuits against negligent parties for different issues such as inadequate security, wrong hiring practices and also lawsuits against schools, companies, nursing homes, employers, hotels, apartment complexes, say care centers and more. You can get quotations from several lawyers and choose the one that best fits your budget. But ensure that you choose a competent lawyer by interviewing them before hiring. bRemember that an efficient lawyer can make a big difference to your case, so it is important that you spend some time in finding the best lawyer to seek advice from for your legal matters.
    `,
    comments: [
      {
        user: `Benjamin`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
      {
        user: `Rhema`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
    ],
  },
  {
    id: 6,
    img: blogImg3,
    title: ` Were you involved in a car accident?`,
    article: `If you are a victim of crime, you need the help of a professional lawyer who is responsive and compassionate.  While you cannot stop crime from happening, you can help others as your lawsuits against the responsible perpetrator will help them to improve their security and ensure that such crimes do not happen in the future.
    Many online self-help legal websites provide free legal advice to people. You can submit your questions online on these websites and then they are answered by lawyers or paralegals.
    We can also help you with lawsuits against negligent parties for different issues such as inadequate security, wrong hiring practices and also lawsuits against schools, companies, nursing homes, employers, hotels, apartment complexes, say care centers and more. You can get quotations from several lawyers and choose the one that best fits your budget.
    But ensure that you choose a competent lawyer by interviewing them before hiring. bRemember that an efficient lawyer can make a big difference to your case, so it is important that you spend some time in finding the best lawyer to seek advice from for your legal matters.
    `,
    comments: [
      {
        user: `Benjamin`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
      {
        user: `Rhema`,
        comment: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ligula nibh, interdum non enim sit amet, iaculis aliquet nunc.`,
      },
    ],
  },
];
